import { BaseFieldMaterialRenderer } from "./base-field-material-renderer";
import { PotentialValue, Value } from "common/components/types";
import { asNumber, asString, loadedDefinedMap } from "common/components/component-helpers";
import { formatLocalizedString, getLocalizedString } from "common/components/localization";
import { GlideFunctionalRenderer } from "common/components/uis";

export const TextFieldMaterialRenderer: GlideFunctionalRenderer = p => {
    const convertIn = (input: Value): string => {
        if (input === undefined) {
            return "";
        }
        return asString(input);
    };

    const getErrorMessage = (
        input: string,
        isRequired: boolean,
        args: readonly PotentialValue[]
    ): string | undefined => {
        const [, , , , , , , minimumChars] = args;

        const min = loadedDefinedMap(minimumChars, asNumber);

        if (input.length === 0 && isRequired) {
            return getLocalizedString("required");
        }

        if (min === undefined || (input.length === 0 && !isRequired) || input.length >= min) return undefined;

        return formatLocalizedString("charactersRequired", [min.toString()]);
    };

    return <BaseFieldMaterialRenderer {...p} dataType="text" convertIn={convertIn} getErrorMessage={getErrorMessage} />;
};
